export default {
	title: 'networks',
	components: [
		{ title: 'wifi_mode_client', component: 'wifi_mode_client_gen_2' },
		{ title: 'wifi_client_backup', component: 'wifi_client_backup_gen_2' },
		{ title: 'wifi_mode_ap', component: 'wifi_mode_ap_gen_2' },
		{
			title: 'outbound_websocket',
			component: 'outbound_ws',
			min_ver: '0.10.4',
		},
		{ title: 'rpc_over_udp', component: 'rpc_over_udp', min_ver: '0.14.0' },
		{ title: 'cloud', component: 'cloud_gen_2' },
		{ title: 'mqtt', component: 'mqtt_gen_2' },
	],
};
